var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#524F4E",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 20.25C14.9018 20.2501 14.8042 20.2308 14.7132 20.1931C14.6222 20.1554 14.5395 20.1001 14.4699 20.0303L6.96993 12.5303C6.90028 12.4607 6.84503 12.378 6.80734 12.287C6.76964 12.196 6.75024 12.0985 6.75024 12C6.75024 11.9015 6.76964 11.804 6.80734 11.713C6.84503 11.622 6.90028 11.5393 6.96993 11.4697L14.4699 3.96965C14.6106 3.829 14.8014 3.74998 15.0003 3.74998C15.1992 3.74998 15.39 3.829 15.5306 3.96965C15.6713 4.11031 15.7503 4.30108 15.7503 4.5C15.7503 4.69891 15.6713 4.88968 15.5306 5.03034L8.56096 12L15.5306 18.9697C15.6355 19.0745 15.707 19.2082 15.7359 19.3537C15.7648 19.4992 15.75 19.65 15.6932 19.787C15.6364 19.9241 15.5403 20.0412 15.417 20.1236C15.2936 20.206 15.1486 20.25 15.0003 20.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevSlide);
export default __webpack_public_path__ + "static/media/prev-slide.7b58f011e8b86fb2309e9ea226383483.svg";
export { ForwardRef as ReactComponent };